module.exports = __webpack_public_path__ + "static/media/experiment-2.03eab5bc.PNG";